import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e9e67b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "portfolio-grid" }
const _hoisted_2 = { class: "portfolio-title-container" }
const _hoisted_3 = { class: "portfolio-title" }
const _hoisted_4 = { class: "nav-button" }
const _hoisted_5 = { class: "with-icon clear" }
const _hoisted_6 = { class: "v" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 2,
  class: "youtube-modal"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 3 }
const _hoisted_12 = {
  class: "video-modal",
  controls: "",
  preload: "false",
  crossorigin: "anonymous",
  cors: "anonymous",
  "data-setup": "{}"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 4,
  style: {"color":"#A9A9AC"}
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "h" }
const _hoisted_19 = { class: "portfolio-content" }
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 3,
  class: "resizable-iframe"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 4,
  style: {"color":"#A9A9AC"}
}
const _hoisted_26 = ["innerHTML"]

import {getCurrentInstance, ref} from 'vue'
import {useRouter} from 'vue-router';
import {NButton, NTooltip} from 'naive-ui'
import Pagination from '@/components/Pagination.vue'

import axios from "axios";
import store from "@/store";
import Modal from "@/components/Modal.vue";

import {InformationOutline, PencilOutline, TrashCanOutline} from "mdue";
import {PortfolioModel} from "@/types/PortfolioModel";



export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioList',
  props: {
    editable: { type: Boolean },
    url: null
  },
  setup(__props: any) {

const props = __props as {
  editable?: boolean,
  url?: string
}



const portos = ref<PortfolioModel[] | null>([])
const totalPortos = ref(0)
const app = getCurrentInstance()
const message = app!.appContext.config.globalProperties.message
const modal = ref([])
const currentModalI = ref(0)
const currentPage = ref(1)

getPortfolio(currentPage.value)

async function getPortfolio(page: any) {
  await axios.get(props.url + `?page=${page}`)
      .then(response => {
        portos.value = response.data.results
        totalPortos.value = response.data.count
      })
      .catch(error => console.log(error))
}

const router = useRouter();
const test = ref(null)

function hapus(id: number) {
  axios.delete(`/api/portfolio/${id}`,
      {headers: {Authorization: `Bearer ${store.state.token}`}}
  )
      .then(response => {
        message.success("Portfolio is successfully removed!", {showIcon: true, closable: true})
        getPortfolio(currentPage.value);
        (modal.value as any)[currentModalI.value].showModal = false;
      })
      .catch((error) => {
        message.error("A problem is occurred when removing portfolio. Please try again", {
          showIcon: true,
          closable: true
        })
        console.log(error)
      })
}

function batal(i: number) {
  console.log(test);
  (modal.value as any)[i].showModal = false
}

function edit(id: number) {
  router.push('/portfolio/edit/' + id)
}

function submitPage() {
  router.push('/portfolio/submit')
}

function onPageChange(page: number) {
  currentPage.value = page;
  getPortfolio(page);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", {
        class: "portfolio-card",
        id: "tambah-button",
        onClick: submitPage
      }, null, 512), [
        [_vShow, __props.editable]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(portos.value, (porto, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "portfolio-card",
          key: i,
          size: "small"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(porto.title), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(Modal, null, {
                trigger: _withCtx(() => [
                  _createVNode(_unref(NTooltip), null, {
                    trigger: _withCtx(() => [
                      _createElementVNode("button", _hoisted_5, [
                        _createVNode(_unref(InformationOutline), { style: {"font-size":"24px"} })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" View Details ")
                    ]),
                    _: 1
                  })
                ]),
                content: _withCtx(() => [
                  _createElementVNode("h3", null, _toDisplayString(porto.title), 1),
                  _createElementVNode("div", _hoisted_6, [
                    (porto.type === 'Image')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: porto.file_url,
                          alt: ""
                        }, null, 8, _hoisted_7))
                      : _createCommentVNode("", true),
                    (porto.type === 'Audio')
                      ? (_openBlock(), _createElementBlock("audio", {
                          key: 1,
                          controls: "",
                          src: porto.file_url
                        }, "Your browser does not support the audio tag. ", 8, _hoisted_8))
                      : _createCommentVNode("", true),
                    (porto.type === 'Youtube')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("iframe", {
                            class: "aspect-ratio-content",
                            title: "YouTube Embed",
                            src: porto.youtube_url,
                            allowfullscreen: "allowfullscreen"
                          }, null, 8, _hoisted_10)
                        ]))
                      : _createCommentVNode("", true),
                    (porto.type === 'Video')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("video", _hoisted_12, [
                            _createElementVNode("source", {
                              ref_for: true,
                              ref: "videoSource",
                              src: porto.file_url
                            }, null, 8, _hoisted_13)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!porto.description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Portfolio ini belum memiliki deskripsi"))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 5,
                          innerHTML: porto.description
                        }, null, 8, _hoisted_15))
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(NTooltip), null, {
                trigger: _withCtx(() => [
                  _withDirectives(_createElementVNode("button", {
                    class: "edit with-icon clear",
                    id: "edit",
                    onClick: ($event: any) => (edit(porto.id))
                  }, [
                    _createVNode(_unref(PencilOutline), { style: {"font-size":"24px"} })
                  ], 8, _hoisted_16), [
                    [_vShow, __props.editable]
                  ])
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Edit ")
                ]),
                _: 2
              }, 1024),
              _createVNode(Modal, {
                ref_for: true,
                ref: el => modal.value[i] = el
              }, {
                trigger: _withCtx(() => [
                  _createVNode(_unref(NTooltip), null, {
                    trigger: _withCtx(() => [
                      _withDirectives(_createElementVNode("button", {
                        class: "hapus with-icon clear",
                        id: "delete",
                        onClick: () => {currentModalI.value = i}
                      }, [
                        _createVNode(_unref(TrashCanOutline), { style: {"font-size":"24px"} })
                      ], 8, _hoisted_17), [
                        [_vShow, __props.editable]
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" Remove ")
                    ]),
                    _: 2
                  }, 1024)
                ]),
                content: _withCtx(() => [
                  _createTextVNode(" Are you sure you want to remove portfolio \"" + _toDisplayString(porto.title) + "\"? ", 1),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_unref(NButton), {
                      type: "default",
                      onClick: ($event: any) => (batal(i))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Cancel ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_unref(NButton), {
                      class: "hapus accent",
                      id: "confirm",
                      type: "primary",
                      onClick: ($event: any) => (hapus(porto.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Remove ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                _: 2
              }, 1536)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            (porto.type === 'Image')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: porto.file_url,
                  alt: ""
                }, null, 8, _hoisted_20))
              : _createCommentVNode("", true),
            (porto.type === 'Audio')
              ? (_openBlock(), _createElementBlock("audio", {
                  key: 1,
                  controls: "",
                  src: porto.file_url
                }, "Your browser does not support the audio tag. ", 8, _hoisted_21))
              : _createCommentVNode("", true),
            (porto.type === 'Video')
              ? (_openBlock(), _createElementBlock("video", {
                  controls: "",
                  preload: "false",
                  crossorigin: "anonymous",
                  cors: "anonymous",
                  "data-setup": "{}",
                  key: porto.file_url,
                  style: {"width":"100%","height":"100%"}
                }, [
                  _createElementVNode("source", {
                    ref_for: true,
                    ref: "videoSource",
                    src: porto.file_url
                  }, null, 8, _hoisted_22)
                ]))
              : _createCommentVNode("", true),
            (porto.type === 'Youtube')
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("iframe", {
                    title: "YouTube Embed",
                    src: porto.youtube_url,
                    allowfullscreen: "allowfullscreen"
                  }, null, 8, _hoisted_24)
                ]))
              : _createCommentVNode("", true),
            (!porto.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_25, "This portfolio has no description yet"))
              : (_openBlock(), _createElementBlock("div", {
                  key: 5,
                  innerHTML: porto.description
                }, null, 8, _hoisted_26))
          ])
        ]))
      }), 128))
    ]),
    _createVNode(Pagination, {
      maxVisibleButtons: 5,
      totalPages: Math.ceil(totalPortos.value / (props.editable ? 5 : 6)) || 1,
      perPage: (props.editable ? 5 : 6),
      currentPage: currentPage.value,
      artists: portos.value,
      ref_key: "test",
      ref: test,
      onPagechanged: onPageChange
    }, null, 8, ["totalPages", "perPage", "currentPage", "artists"])
  ], 64))
}
}

})